import React, { Component } from 'react';
import { connect } from 'formik';
import Input from '../../../../components/input/text/input-formik';
import { ILinkActivityAddProps, IOuterProps, IFormikProps } from '../../../../models/components/add-activity-link-content';
import { Quil } from '../../../../components/input/quil/main';
import { SelectNoneAsync } from '../../../../components/input/select/main';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Confirm, Notification } from '../../../../components/notification/main';
import { Common } from '../../../../core/common';
import { ActivityTiming } from '../../../../components/add-activity/timing';
import { LinkService } from '../../../../api/link-page-service';
import ContentLoader from 'react-content-loader';
import Loading from '../../../../components/loading/loading';
import * as coreActions from '../../../../store/actions/core';
import BaseModal from '../../../../modal/base-modal/main';
import { ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import Tooltip from '../../../../components/tooltip/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;
const _linkService = new LinkService();

export class LinkActivityContent extends Component<IFormikProps, any> {
    _deletedFilesId = this.props.formik.values.deletedFilesId;

    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            isModelOpen: false,
            url: '',
            title: '',
            description: '',
            imgSrc: '',
            isTeamsModelOpen: false
        };
    }

    public onClickDeleteFile = (fileId: string, fileName: string) => {
        Confirm.setConfirm('normal', () => this.deleteFile(fileId, fileName), T.t('r_delete_file_question'), null);
    };

    public deleteFile = (fileId: string, fileName: string) => {
        this.setState({ isModelOpen: true });
        this._deletedFilesId.push(fileId);
        this.props.formik.setFieldValue('deletedFilesId', this._deletedFilesId);
        const fileDiv = document.getElementById(fileName);
        if (fileDiv) {
            fileDiv.classList.add('fadeOut');
            fileDiv.classList.add('animated');
            fileDiv.classList.add('hide');
            setTimeout(() => {
                if (fileDiv.parentNode) fileDiv.parentNode.removeChild(fileDiv);
            }, 1000);
        }
    };

    public timingControl = (type: number) => {
        this.props.formik.values.dateCriteria === type
            ? this.props.formik.setFieldValue('dateCriteria', -1)
            : this.props.formik.setFieldValue('dateCriteria', type);
    };

    public clickToDownload = (e: any) => {
        let filepath = '';
        let fileName = '';

        if (e && e.currentTarget) {
            filepath = e.currentTarget.getAttribute('data-filepath').toString();
            fileName = e.currentTarget.getAttribute('data-filename').toString();
        }

        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    componentDidMount = async () => {
        if (
            this.props.isUpdate &&
            this.props.formik &&
            this.props.formik.values &&
            this.props.formik.values.url &&
            this.props.formik.values.customProperty3 !== '6'
        ) {
            await this.searchUrl(this.props.formik.values.url, this.props.formik);
        }

        window.addEventListener('message', this.getTeamsDetail, true);
    };

    componentWillUnmount = () => {
        window.removeEventListener('message', this.getTeamsDetail, true);
    };

    getTeamsDetail = (event: any) => {
        if (
            this.props.formik &&
            event &&
            event.data &&
            event.origin &&
            typeof event.origin === 'string' &&
            event.origin.indexOf('teams.almscloud.com') !== -1
        ) {
            const description = T.t('r_link_activity_desc', { 0: event.data.split('~')[1], 1: event.data.split('~')[2] });
            const name = event.data.split('~')[0];
            const url = event.data.split('~')[3];

            this.props.formik.setFieldValue('name', name);
            this.props.formik.setFieldValue('description', description);
            this.props.formik.setFieldValue('url', url);
        }
    };

    public onChangeUrl = async (e: any, formik: any) => {

        if (e && e.target && formik && formik.values && formik.values.customProperty3 !== '6') {
            const urlValue = e.target.value!;
            await this.searchUrl(urlValue, formik);
        }
    };

    searchUrl = async (urlValue: any, formik: any, notSetField?: boolean) => {
        formik.setFieldValue('url', urlValue);
        this.setState({ url: urlValue });
        try {
            const params = urlValue;

            if (params) {
                let isError = false;
                let errorList: any;
                let pageData: any;
                this.props.dispatch(coreActions.setSpinner('getLinkSearch', 'get'));
                await _linkService
                    .RequestSearchKeyAsync(params)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData.json();
                    })
                    .then(response => {
                        if (isError) {
                            errorList = response;
                        } else {
                            pageData = response;
                        }
                    });

                if (isError) {
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    });
                } else {

                    formik.setFieldValue('name', pageData.title);
                    //formik.setFieldValue('description', pageData.description);
                    formik.setFieldValue('customProperty4', pageData.imageUrl);

                    this.setState({
                        imgSrc: pageData.imageUrl,
                       // url: pageData.url,
                        title: pageData.title,
                        //description: pageData.description
                    });

                    this.props.dispatch(coreActions.setSpinner('getLinkSearch', 'set'));
                }
            }
        } catch {
            Notification.setNotification('error', T.t('r_link_url_get_error_message'), 'topRight');
        }
    };

    triggerTeamsModal = () => {
        this.setState({
            isTeamsModelOpen: !this.state.isTeamsModelOpen
        });
    };

    handleChangeSelect = (event: any, action: any) => {
        if (event && event.value) {
            this.props.formik.setFieldValue('customProperty3', event.value);
            this.props.formik.setFieldValue('name', '');
            this.props.formik.setFieldValue('description', '');
            this.props.formik.setFieldValue('customProperty4', '');
            this.props.formik.setFieldValue('url', '');

            this.setState({
                imgSrc: '',
                url: '',
                title: '',
                description: ''
            });

            if (event.value === '6' && action) {
                this.triggerTeamsModal();
            }
        }
    };

    public render() {
        const linkGenerators = [
            { value: '0', label: T.t('r_link_generators_none') },
            { value: '6', label: 'Microsoft Teams' }
        ];

        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_contentTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_contentTab' ? 'block' : 'none' }}
                id="forum-setting"
                role="tabpanel"
                aria-labelledby="forum-setting-tab"
            >
                <BaseModal
                    minWidth={750}
                    modalIsOpen={this.state.isTeamsModelOpen}
                    onClose={this.triggerTeamsModal}
                    headerState={'Teams'}
                    showHeader={true}
                >
                    <div style={{ height: 'Calc(100vh - 132px)' }}>
                        <iframe
                            id="idframe"
                            name="idframe"
                            style={{
                                overflow: 'hidden',
                                overflowX: 'hidden',
                                overflowY: 'hidden',
                                height: '100%',
                                width: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                border: 0
                            }}
                            height="100%"
                            width="100%"
                            src="https://teams.almscloud.com"
                        />
                    </div>
                </BaseModal>
                <h5 className="mb-0">{T.t('r_link_generator')}</h5>
                <div className="col" style={{ padding: '0px', marginTop: '10px' }}>
                    <SelectNoneAsync
                        isMulti={false}
                        name={'customProperty3'}
                        touched={this.props.formik.touched.customProperty3}
                        errors={this.props.formik.errors.customProperty3}
                        setFieldValue={this.props.formik.setFieldValue}
                        setOptions={linkGenerators}
                        onChange={this.handleChangeSelect}
                        isTouched={this.props.formik.setFieldTouched}
                        placeHolder={T.t('r_link_generator_select')}
                        setSelectValue={this.props.isUpdate ? [this.props.formik.values.customProperty3] : ['0']}
                        isClearable={false}
                    />
                    <Loading spinnerId={'getLinkSearch'}>
                        <div style={{ backgroundColor: 'rgb(251 250 246)', marginTop: 10, marginBottom: 20 }}>
                            <ContentLoader
                                speed={2}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                style={{ width: '100%', height: '100%' }}
                                preserveAspectRatio="xMinYMin meet"
                            >
                                <rect x="0" y="10" rx="3" ry="3" width="33.5%" height="100%" />
                                <rect x="275" y="10" rx="3" ry="3" width="45%" height="10" />
                                <rect x="215" y="40" rx="3" ry="3" width="65%" height="16" />
                                <rect x="310" y="65" rx="3" ry="3" width="30%" height="16" />
                                <rect x="215" y="100" rx="3" ry="3" width="65%" height="9" />
                                <rect x="220" y="117" rx="3" ry="3" width="62.5%" height="9" />
                                <rect x="300" y="134" rx="3" ry="3" width="33%" height="9" />
                            </ContentLoader>
                        </div>
                    </Loading>
                    <div className="row" id="getLinkSearch_ContentFlex" style={{ marginBottom: 0 }}>
                        {this.state.url ? (
                            <>
                                <div className="col-md-4">
                                    <img
                                        src={this.state.imgSrc ? this.state.imgSrc : _common.GetDefaultIcons('videolinkphoto')}
                                        style={{ maxWidth: '200px', marginBottom: '20px' }}
                                    />
                                </div>
                                <div className="col-md-8" style={{ marginBottom: '20px' }}>
                                    <div className="row" style={{ margin: '0px', justifyContent: 'center', fontSize: 12, marginBottom: 5 }}>
                                        {this.state.url}
                                    </div>
                                    <div
                                        className="row"
                                        style={{
                                            margin: '0px',
                                            justifyContent: 'center',
                                            textAlign: 'center',
                                            fontSize: 16,
                                            marginBottom: 5
                                        }}
                                    >
                                        {this.state.title}
                                    </div>
                                    <div
                                        className="row"
                                        style={{
                                            margin: '0px',
                                            justifyContent: 'center',
                                            textAlign: 'center',
                                            fontSize: 11,
                                            marginBottom: 5
                                        }}
                                    >
                                        {this.state.description}
                                    </div>
                                </div>
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </div>

                <Input
                    disable={this.props.formik.values.customProperty3 === '6'}
                    type={'text'}
                    name={'url'}
                    placeHolder={'Url'}
                    onChange={this.onChangeUrl}
                    formik={this.props.formik}
                    
                />

                <h5 className="mb-0 mt-4">{T.t('r_activity_search_placeholder')}<span className="ml-1" style={{ color: '#dc5050' }}>*</span></h5>
                <Input type={'text'} name={'name'} placeHolder={T.t('r_activity_search_placeholder')} formik={this.props.formik} />
                <p className="half-color">{T.t('r_activity_list_shown_text')}</p>
                <h5 className="mt-4 mb-2">{T.t('r_description')}</h5>
                <Quil
                    modules={'basic'}
                    placeholder={T.t('r_write_description_for_activity')}
                    /* tslint:disable */
                    onChange={(e: any) => this.props.formik.setFieldValue('description', e)}
                    value={this.props.formik.values.description}
                    theme={'snow'}
                />
                {this.props.formik.values.file && this.state.isModelOpen === false ? (
                    ''
                ) : (

                    ''
                )}
                {this.props.formik.values.file
                    ? this.props.formik.values.file.map((file: any) => {
                        return (
                            <div
                                key={file.fileName}
                                id={file.fileName}
                                className="row"
                                style={{ paddingLeft: '15px', paddingRight: '15px', marginTop: '10px' }}
                            >
                                <p>
                                    <b>{T.t('r_file')} </b>
                                    <a
                                        target="_blank"
                                        title={file.fileName}
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '90%'
                                        }}
                                        onClick={this.clickToDownload}
                                        data-filepath={file && file.filePath}
                                        data-filename={file && file.fileName}
                                    >
                                        {file.fileName}
                                    </a>
                                </p>
                                <i
                                    // tslint:disable-next-line
                                    onClick={() => this.onClickDeleteFile(file.fileId, file.fileName)}
                                    className="material-icons del-icon del-icon-color"
                                    style={{ marginLeft: 'auto', cursor: 'pointer' }}
                                >
                                    delete
                                </i>
                            </div>
                        );
                    })
                    : ''}

                {!this.props.isProjectSubActivity && (
                    <>
                        <ActivityTiming
                            coursePageActivityId={this.props.coursePageActivityId}
                            coursePageClassId={this.props.coursePageClassId}
                            dateFormat={this.props.dateFormat}
                            formik={this.props.formik}
                            isUpdate={this.props.isUpdate}
                            isWeekly={this.props.isWeekly}
                            termType={this.props.termType ?? T.t('r_time_week')}
                            activityType={this.props.activityType}
                        />

                        <div className='d-flex align-items-center'>
                            <h5 className="mt-4 mt-0">{T.t('r_activity_finish_criteria')}</h5>
                            <Tooltip data={T.t('r_activity_finish_criteria_info')} position='top'>
                                <img src={_common.GetDefaultIcons('info')} style={{ width: '1.25em', marginInlineStart: "20px"  }} alt="" />
                            </Tooltip>
                        </div>
                        {this.props && this.props.isUpdate != "" ?
                            <div className="row">
                                {this.props.formik.values.completionType === ActivityCompletionType.View ?
                                    <div className="col-md-4">
                                        <div className="radio-tabs tick-radio position-relative">
                                            <input
                                                type="radio"
                                                name={'completionType'}
                                                value={ActivityCompletionType.View}
                                                defaultChecked={true}
                                                onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                                id="completion-type-view"
                                                className="form-radio"
                                                checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                            />
                                            <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                                        </div>
                                    </div>
                                    : null}
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative">
                                        <input
                                            type="radio"
                                            name={'completionType'}
                                            value={ActivityCompletionType.View}
                                            defaultChecked={true}
                                            onChange={this.props.formik.setFieldValue.bind(this, 'completionType', ActivityCompletionType.View)}
                                            id="completion-type-view"
                                            className="form-radio"
                                            checked={this.props.formik.values.completionType === ActivityCompletionType.View ? true : false}
                                        />
                                        <label htmlFor="completion-type-view">{T.t('r_display')}</label>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                )}
            </div>
        );
    }
}

export default connect<ILinkActivityAddProps, IOuterProps>(LinkActivityContent);
